var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0637c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002caa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdd33f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fed02f"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#c)",
    height: 11.428571,
    mask: "url(#e)",
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.04761905 9.14285714h11.42857145v.76190476h-12.19047621zm5.71428571-4.57142857c2.28571424-1.52380952 4.95238094-3.04761905 4.95238094-3.04761905s-1.251547 2.34167257-1.1428571 3.42857143c.1452784 1.45278367 1.9047619 3.42857143 1.9047619 3.42857143h-10.66666669s2.66666667-2.28571428 4.95238095-3.80952381z",
    fill: "url(#d)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.04761905 6.85714286-.53874803.15779564.15779565-.53874802-.15779565-.53874803.53874803.15779565.53874802-.15779565-.15779564.53874803.15779564.53874802z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.80952381 1.9047619-.53874802.15779565.15779564-.53874803-.15779564-.53874802.53874802.15779564.53874802-.15779564-.15779564.53874802.15779564.53874803z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.33333333 4.19047619-.53874802.15779564.15779564-.53874802-.15779564-.53874802.53874802.15779564.53874803-.15779564-.15779565.53874802.15779565.53874802z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.52380952 4.19047619-.53874802.15779564.15779564-.53874802-.15779564-.53874802.53874802.15779564.53874803-.15779564-.15779565.53874802.15779565.53874802z",
    mask: "url(#e)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTk);
export default __webpack_public_path__ + "static/media/TK.cedaee4822dff688b03c09ac32619592.svg";
export { ForwardRef as ReactComponent };